export default {
  namespaced: true,
  state: {
    byId: {
      1: '時間別',
      2: '日別',
      3: '曜日別',
      4: '月別',
      5: '順位',
    },
    shortById: {
      1: '時',
      2: '日',
      3: '曜日',
      4: '月',
      5: '件',
    },
    allIds: [1, 2, 3, 4, 5],
  },
  mutations: {},
  getters: {
    isHourly: () => unit => unit === 1,
    isDaily: () => unit => unit === 2,
    isWeekly: () => unit => unit === 3,
    isMonthly: () => unit => unit === 4,
    isRanking: () => unit => unit === 5,
  },
  actions: {},
}
